import './App.css';
import { Routes, Route } from 'react-router-dom'

import { FirebaseProvider } from './providers/firebase';

import HomePage from './pages/Home';
import PublicationsPage from './pages/Publications';
import ReasearchProjectsPage from './pages/ReasearchProjects';
import ContactsPage from './pages/Contacts';
import Navbar from './components/Navbar';
import ResearchPage from './pages/Research';
import ResearchDomainsPage from './pages/ResearchDomains';
import PastScholars from './pages/PastScholars';
import People from './pages/People';
import Collaborations from './pages/Collaborations';
import LabFacility from './pages/LabFacility'
import Photos from './pages/Photos'
import { AuthContextProvider } from './providers/authentication';

function App() {
  return (
    <div className="App">
      <FirebaseProvider>
        <AuthContextProvider>
          <Navbar />
          <Routes>
            <Route path='/' element={<HomePage />}></Route>
            <Route path='/publications' element={<PublicationsPage />}></Route>
            <Route path='/research-projects' element={<ReasearchProjectsPage />}></Route>
            <Route path='/research' element={<ResearchPage />}></Route>
            <Route path='/contacts' element={<ContactsPage />}></Route>
            <Route path='/research-domains' element={<ResearchDomainsPage />}></Route>
            <Route path='/past-scholars' element={<PastScholars />}></Route>
            <Route path='/people' element={<People />}></Route>
            <Route path='/collaborations' element={<Collaborations />}></Route>
            <Route path='/lab-facilities' element={<LabFacility />}></Route>
            <Route path='/photos' element={<Photos />}></Route>
          </Routes>
        </AuthContextProvider>
      </FirebaseProvider>

    </div>
  );
}

export default App;